import _ from 'lodash';
import { MobileAssessmentButton } from 'pages/MindUp/Assessments/Components/AssessmentButton';
import styled from 'styled-components';
import { AssessmentStatus } from 'utils/statusCode';
import { assessmentType } from 'pages/MindUp/Assessments/InspectionGuidePage';
import { childReportByParent, childSelfReport, parentSelfReport } from 'constants/viewDetailDiagnosisPageConstants';
import { changeAssessmentApiResponse } from 'models/Tablet/AssessmentApiTypes';
import { GetResultDiagnosisApiResponse } from 'models/DCK/DCKApiTypes';

export default function InpsytResults({ diagnosisInfo, assessmentResult }: { diagnosisInfo: changeAssessmentApiResponse; assessmentResult?: GetResultDiagnosisApiResponse }) {
    return (
        <AssessmentListContainer>
            {_.map(diagnosisInfo.assessmentList, (assessment, index) => {
                const getAssessmentType = () => {
                    if (_.includes(parentSelfReport, assessment.assessmentCode)) {
                        return assessmentType.forParents;
                    }

                    if (_.includes(childReportByParent, assessment.assessmentCode)) {
                        return assessmentType.byParents;
                    }

                    return assessmentType.byChild;
                };

                return (
                    <MobileAssessmentButton
                        $title={assessment.group}
                        $subTitle={''}
                        $desc={_.first(_.split(assessment.assessmentName, '(')) ?? ''}
                        $label={getAssessmentType()}
                        $type={getAssessmentType()}
                        $bedgeType='strong'
                        $number={Number(index) + 1}
                        $subName={assessment.subName}
                        $assessmentStatus={AssessmentStatus.standBy}
                        $diagnosisStatus={diagnosisInfo.status}
                        isDisable={false}
                        $onClick={async () => {
                            const foundAssessment = _.filter(assessmentResult?.data, (e) => e.ozJsonInfoData.PSY_ITEM_ID === assessment.assessmentCode);

                            window.location.href = `${foundAssessment[0].ozUrl}`;
                        }}
                    />
                );
            })}
        </AssessmentListContainer>
    );
}

const AssessmentListContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 12px;
`;
